const isResValid = response => {
  if (response.data && response.data.result && response.data.result.data !== undefined) {
    return true
  }
  return false
}

export default isResValid
